import { Validator } from '@vista-digital/validator';
import { OccSeatingScreenPosition, occSeatingScreenPositionValidator } from './screen-position';
export const defaultOccSeatingScreenConfig = {
    height: 35,
    margin: 10,
    bevelOffset: 30,
    position: OccSeatingScreenPosition.Top
};
export const occSeatingScreenConfigValidator = Validator.object({
    height: Validator.number({ min: 0 }),
    margin: Validator.number({ min: 0 }),
    bevelOffset: Validator.number({ min: 0 }),
    position: occSeatingScreenPositionValidator
});
//# sourceMappingURL=screen.js.map